import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';
import { ZalamoObject } from '../../../../../graphql';

@Component({
    selector: 'app-look-book-created',
    templateUrl: './look-book-created.component.html',
    styleUrls: ['./look-book-created.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LookBookCreatedComponent implements OnInit {
  @Input()
  @ParseJson
  details: UserWallEvent[UserWallEventType.LookBookCreated];

  ob: ZalamoObject = ZalamoObject.OrganizationClient;

  constructor() {}

  ngOnInit(): void {}
}
